<div class="header-admin-navbar">
  <button class="back-button" (click)="location.back()">
    <i class="fa-regular fa-arrow-left"></i>
  </button>
  <!-- <div class="search-container">
    <div class="search-container-content">
      <input type="text" name="search" placeholder="Search here.." />
    </div>
  </div> -->
  <div class="flex-r gap-10 align-center">
    <!-- <div class="notifications">
      <i class="fa-regular fa-bell"></i>
    </div> -->
    <div class="user">
      <button
        class="user-container inwi-text-button-large-secondary"
        (click)="userMenu.toggle($event)">
        <app-avatar
          class="avatar"
          size="x-small"
          [user]="userService.currentUser$.value"></app-avatar>
        <div class="user-name">
          {{
            userService.getUser()?.firstname +
              ' ' +
              userService.getUser()?.lastname
          }}
        </div>
        <div class="user-expander">
          <i class="fa-solid fa-chevron-down"></i>
        </div>
      </button>

      <p-menu #userMenu [model]="menuItems" [popup]="true">
        <ng-template pTemplate="item" let-item>
          <a
            pRipple
            class="flex align-items-center p-menu-item-link icon-24"
            [routerLink]="item.link"
            [queryParams]="item.queryParams">
            <i [class]="item.icon"></i>
            <span class="ml-2">{{ item.label }}</span>
          </a>
        </ng-template>
      </p-menu>
    </div>
  </div>
</div>
